import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@adobe/cq-react-editable-components';

import { FWAContainer } from '../../../../common/FWAContainer';
import { Row, Col } from '../../../../common/Grid';
import '../contactInfo.css';
import ContactInfoButton from '../Components/contactInfoButton';
import MiniCart from '../../../../common/MiniCart/redesign';
import {
  getAPPID,
  getSession,
  isPreorder,
  isMobile,
  isDesktopResolution,
  getUrlName,
  getFlowType,
  getCookie,
} from '../../../../common/Helpers/index';
import { goToProcessStep } from '../../../../../redirection';
import Notification from '../../../../common/Notification/redesign/index';
import { store } from '../../../../../configureStore';
import { checkCartidAndLQResponse, redirectToHomePage } from '../../../../common/Helpers/commonLog';
import { getChannelId } from '../../../../../services/HttpService';
import { callPerformanceMeasure } from '../../../../common/Helpers/performanceMeasure';
import { unParseNumber } from '../../../../common/ContactInfoUtils';
import { performPreFetch, notificationProps } from '../../Common/indexCommon';
import logger from "../../../../common/ErrorBoundary/logger_new";

export default class ContactInfo extends Container {
  constructor(props) {
    super(props);
    checkCartidAndLQResponse('contactInfo');
    this.isMobile = isMobile();
    this.handleLoad = this.handleLoad.bind(this);
  }

  componentDidMount() {
    window.addEventListener('load', this.handleLoad);
    document.title = 'Verizon Wireless';

    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        performPreFetch();
      }
    };
    const isLoggedIn = getCookie('loggedIn');
    if (isLoggedIn === 'true' || isLoggedIn === true) {
      this.props.getCheckOutDetails({ paymentOptions: this.props.setupType === 'Prof', cart: true, shippingOptions: isPreorder() });
    }

    // need to update the props based on the getCheckout value in parent
    if (this.props.setupType === 'Prof') {
      if (this.props?.eidQuestionsFromCreditStatus?.numOfQuestions > 0) {
        store.dispatch({ type: 'CLEAR_CREDIT_CHECK_RESPONSE' });
      }
    }
    // need to update the props based on the getCheckout value in parent

    if (isPreorder() && isLoggedIn === 'true') {
      let homePhoneAdded = false;

      const homePhoneResponse = this.props?.getCheckOutState ? this.props?.getCheckOutState?.data?.cart?.lineDetails?.lineInfo?.newLine2 : {};
      if (homePhoneResponse && Object.keys(homePhoneResponse)?.length > 0) {
        homePhoneAdded = true;
      }
      //    nwhether to use getChechout/retrieve shipping options
      this.props.buildShippingOptionsInputFromContactinfo(
        this.props.ShippingInfoDetails?.lines?.[0]?.shippingOptions?.[0],
        null,
        null,
        homePhoneAdded,
      );
      //  removed full account number
      this.props.contactFetchSMSEnabledDevices();
    }
    this.props.editContactInfo('continue'); // button name in aalflow
    this.props.showCart(false); // minicart expanded or collapsed
    // this.props.invokeTaggingAPI(); // taggingapi

    if (this.props.contactInfoEditError && this.props.contactInfoEditError !== '') {
      this.props.updateContactInfoEditError('');
    }

    store.dispatch({ type: 'CLEAR_PERSONAL_API_ERROR', value: true }); // value is not needed
    store.dispatch({ type: 'CEF_CONTACT_INFO_ERROR', response: false, errorMessage: null });
    store.dispatch({ type: 'API_LOADED', response: true });
  }

  handleLoad = () => {
    const pageName = getUrlName(window.location.href);
    const markerValue = `${pageName}:ui:${getChannelId()}:${getFlowType()}:render`;

    if (window?.performance?.measure) {
      window.performance.measure(markerValue);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad);
  }

  componentDidUpdate() {
    if (this.props.apiLoaded) {
      callPerformanceMeasure();
      store.dispatch({ type: 'API_LOADED', response: false });
    }
    //  once the api is success, we are updating to continue button
    if (this.props.contactInfoEditResponse === 'success') {
      this.props.editContactInfo('continue'); // button name in aalflow
      this.props.updateContactInfoEditResponse('');
    }
  }

  onClickContinue = () => {
    const { currentView, isCreditStatusAvailable, cartDetails, history, creditStatusLanded } = this.props;
    const isNoSlotsAvailable = getSession('isNoSlotsAvailable');
    this.props.updateInfoSuccessFlag();
    // added condtion to toggle success flag again to default state
    this.props.updateISPUContactInfoFlag();
    let updateView;
    // let checkPaymentSelectionUpdatd = this.checkPaymentSelection();
    if (this.props.isLoggedIn !== true && this.props.setupType === 'Prof') {
      updateView = currentView.CreditCheck;
    } else if (this.props.setupType === 'Prof') {
      if (isCreditStatusAvailable) {
        updateView = currentView.CreditStatus;
      } else if (cartDetails?.orderDetails?.totalDueToday !== undefined && parseFloat(cartDetails?.orderDetails?.totalDueToday) === 0) {
        // adding this condition to show new LF redesign page
        updateView = currentView.PRO.OrderReview;
      } else if (cartDetails?.orderDetails?.totalDueToday > 0) {
        if (this.props.isLoggedIn !== true) {
          updateView = currentView.CreditCheck;
        } else if (!this.checkPaymentSelection()) {
          store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: true });
          updateView = currentView.Payment;
        } else if (this.checkPaymentSelection()) {
          updateView = currentView.PRO.OrderReview;
        }
      } else {
        updateView = currentView.PRO.Tos;
      }
    } else if (isPreorder()) {
      if (getAPPID() === 'NSE') {
        updateView = currentView.CreditCheck;
      } else if (getAPPID() !== 'NSE' && isCreditStatusAvailable) {
        updateView = currentView.CreditStatus;
      } else if (isCreditStatusAvailable && !creditStatusLanded) {
        updateView = currentView.CreditStatus;
      } else if (cartDetails?.orderDetails?.totalDueToday === '0.0' && isNoSlotsAvailable !== 'Y') {
        updateView = currentView.OrderReview;
      } else if (isNoSlotsAvailable === 'Y') {
        if (
          this.props.cartSelector &&
          this.props.cartSelector.shippingDetails &&
          this.props.cartSelector.shippingDetails[0] &&
          this.props.cartSelector.shippingDetails[0].shippingCost > 0
        ) {
          if (this.checkPaymentSelection()) {
            updateView = currentView.OrderReview;
          } else {
            updateView = currentView.Payment;
          }
        } else {
          updateView = currentView.OrderReview;
        }
      } else if (cartDetails?.orderDetails?.totalDueToday > 0) {
        if (this.props.isLoggedIn !== true) {
          updateView = currentView.CreditCheck;
        }

        if (this.checkPaymentSelection()) {
          updateView = currentView.OrderReview;
        } else {
          store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: true });
          updateView = currentView.Payment;
        }
      } else {
        updateView = currentView.OrderReview;
      }
      goToProcessStep(updateView, this.props.history);
    } else {
      updateView = currentView.SELF;
      logger({
        json: true,
        eventType: 'FeInfo',
        message: `cart Contact Int route ${JSON.stringify(updateView)}`,
        note: 'call cart Contact Int route from onClickContinue',
        messageType: 'INFO',
      });
    }
    goToProcessStep(updateView, history);
  };

  checkPaymentSelection = () => {
    if (this.props.paymentDoneList && Object.keys(this.props.paymentDoneList).length > 0) {
      return true;
    }
    return false;
  };

  //  function will be called when we click on next button in aal flow
  submitContactInfo = (e) => {
    e.preventDefault();
    let inputdata = {};
    let param = {};
    let cartDetails = {};
    let homePhoneAdded = false;
    const homePhoneResponse = this.props?.getCheckOutState ? this.props?.getCheckOutState?.data?.cart?.lineDetails?.lineInfo?.newLine2 : {};
    if (homePhoneResponse && Object.keys(homePhoneResponse)?.length > 0) {
      homePhoneAdded = true;
    }
    const { firstName, lastName, email, offerCheckboxStatus, phoneNumber } = this.props?.contactFormValues;
    param = [
      {
        firstName,
        lastName,
        email,
        phoneNumber: unParseNumber(phoneNumber), // few place contact info, few places mobile number
        mtn: homePhoneAdded ? 'newLine2' : 'newLine1',
        receiveSpecialOfferUpdates: offerCheckboxStatus,
      },
    ];
    if (this.props?.getCheckOutState?.data?.cart) {
      // TODO : need to verify, removed full account number
      cartDetails = {
        cartCreator: this.props?.getCheckOutState?.data?.cart?.cartHeader?.cartCreator || '',
      };
    }
    inputdata = {
      param,
      cartDetails,
    };
    this.props.postData(inputdata, homePhoneAdded, null, this.props.setupType);
    // this.props.postData(inputdata, homePhoneAdded, null);
  };

  render() {
    const isLoggedIn = getAPPID() === 'AAL';

    let components = this.childComponents;
    let showContinueBTN = true;
    //  this is enable contine/next button logic
    if (this.props.editcontactInfo && this.props.editcontactInfo === 'edit') {
      showContinueBTN = false;
      components = components.filter((item) => item.key.indexOf('/billingInfo') <= 0);
    }
    const headerSection = components.filter((item) => item.key.indexOf('/heading') >= 0 || item.key.indexOf('/subHeading') >= 0);
    const contactInfoComponentsNSE = components.filter(
      (item) =>
        !(
          item.key.indexOf('/miniCartDueToday') >= 0 ||
          item.key.indexOf('/miniCartDueMonthly') >= 0 ||
          item.key.indexOf('/heading') >= 0 ||
          item.key.indexOf('/subHeading') >= 0
        ),
    );
    const contactInfoComponentsAAL = components.filter(
      (item) =>
        !(
          item.key.indexOf('/miniCartDueToday') >= 0 ||
          item.key.indexOf('/miniCartDueMonthly') >= 0 ||
          item.key.indexOf('/secureAccountPin') >= 0 ||
          item.key.indexOf('/heading') >= 0 ||
          item.key.indexOf('/subHeading') >= 0
        ),
    );
    const miniCartComponents = components.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );

    if (
      this.props.shippingInfoState &&
      this.props.shippingInfoState.paymentSkipCall &&
      this.props.cartDetails?.orderDetails?.totalDueToday > 0 &&
      this.props.paymentInfoState
    ) {
      if (this.props.isBTAAvailable && this.props.isBTAAvailable.length > 0) {
        store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: true });
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        store.dispatch({ type: 'CONFIRM_SUBMIT_CALL', value: true });
        // this.props.confirmSubmit(data);
      } else if (this.props.otherPaymentOptions && this.props.otherPaymentOptions.length > 0) {
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        const updateView = this.props.currentView.PRO.Payment;
        goToProcessStep(updateView, this.props.history);
      }
    }
    const notificationValue = notificationProps(this.props);
    const link = document.getElementById('transactionExpiryLink');
    if (link) {
      link.addEventListener('click', redirectToHomePage);
    }

    const button = (
      <ContactInfoButton
        type="button"
        disabled={showContinueBTN ? false : this.props.contactFormValues?.nextButtonEnableStatus || false}
        ariaLabel={showContinueBTN ? 'Continue' : this.props.contact_info_contact_cta || 'Next'}
        analyticstrack={showContinueBTN ? '5G-infoView' : '5G-contactInfoView'}
        onClickContinue={showContinueBTN ? this.onClickContinue : (e) => this.submitContactInfo(e)}
        buttonName={showContinueBTN ? 'Continue' : this.props.contact_info_contact_cta || 'Next'}
      />
    );
    return (
      <div className="contactInfoContainer">
        <Notification {...notificationValue} />

        <FWAContainer enableLiveSupport topBufferAuto title={this.props.title}>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>{headerSection}</Col>
          </Row>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 8 }}>
              {isLoggedIn ? <div>{contactInfoComponentsAAL}</div> : <div>{contactInfoComponentsNSE}</div>}
              {!isDesktopResolution() && <>{button}</>}
            </Col>
            <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
              {isDesktopResolution() && (
                <>
                  <MiniCart
                    miniCartComponents={miniCartComponents}
                    showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                    iscartVisible={this.props.isCartVisible}
                    topMarginStyle={60}
                  />
                  {button}
                </>
              )}
            </Col>
          </Row>
        </FWAContainer>
      </div>
    );
  }
}
ContactInfo.propTypes = {
  pageName: PropTypes.string,
  invokeTaggingAPI: PropTypes.func,
};
